/**
 * Shared types + helpers describing the experiments manifest published by the
 * lab (svc-lab/web-protected) and consumed by the answersnow-web app.
 */

export type ExperimentAudience = "client" | "clinician" | "admin";

export interface ExperimentManifestEntry {
  id: string;
  audience: ExperimentAudience;
  title: string;
  description: string;
  fullscreen: boolean;
  /** `exp_iso_${snake_case(id)}` */
  flag: string;
  /** Path on the lab origin to open in a new tab (rendered chrome-less via `?embed=1`). */
  launchPath: string;
}

export interface ExperimentsManifest {
  generatedAt: string;
  experiments: ExperimentManifestEntry[];
}

export const EXPERIMENT_FLAG_PREFIX = "exp_iso_";

/**
 * Filters the manifest down to experiments the user has enabled for the given
 * audience. Stable ordered by title.
 */
export const getEnabledExperimentsForAudience = (
  manifest: ExperimentsManifest | null | undefined,
  enabledFlags: ReadonlySet<string>,
  audience: ExperimentAudience,
): ExperimentManifestEntry[] => {
  if (!manifest) return [];
  return manifest.experiments
    .filter((e) => e.audience === audience && enabledFlags.has(e.flag))
    .sort((a, b) => a.title.localeCompare(b.title));
};
